import { render, staticRenderFns } from "./TranslationBillingList.vue?vue&type=template&id=4d49aad1"
import script from "./TranslationBillingList.vue?vue&type=script&lang=js"
export * from "./TranslationBillingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports